import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const LEVELS = [
  { range: "0 – 1", label: "Usuario superficial de IA", n: 1, color: "text-slate-400" },
  { range: "1 – 2", label: "Usuario asistido básico", n: 2, color: "text-sky-400" },
  { range: "2 – 3", label: "Profesional aumentado", n: 3, color: "text-cyan-400" },
  { range: "3 – 4", label: "Operador agentic avanzado", n: 4, color: "text-emerald-400" },
  { range: "4 – 5", label: "Arquitecto agentic de productividad", n: 5, color: "text-amber-400" },
];

export default function Matrix() {
  const { data } = useQuery({ queryKey: ["matrix"], queryFn: async () => (await api.get("/matrix")).data });
  const dims = data?.dimensions || [];

  return (
    <div>
      <div className="mb-8">
        <span className="text-xs uppercase tracking-[0.2em] text-primary">Metodología Talent Hackers</span>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight mt-1">Matriz de evaluación agentic</h1>
        <p className="text-slate-400 mt-1.5 max-w-2xl">
          10 dimensiones puntuadas de 0 a 5 con pesos definidos por Talent Hackers. El Agentic Productivity Index es la media ponderada.
        </p>
      </div>

      <div className="rounded-xl border border-slate-800 bg-slate-900 overflow-hidden mb-8">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-800 text-left text-slate-400">
              <th className="px-5 py-3 font-medium">Dimensión</th>
              <th className="px-5 py-3 font-medium hidden md:table-cell">Qué mide</th>
              <th className="px-5 py-3 font-medium text-right">Peso</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800">
            {dims.map((d) => (
              <tr key={d.key} className="hover:bg-slate-800/50 transition-colors duration-200">
                <td className="px-5 py-3.5 font-medium text-slate-100">{d.name}</td>
                <td className="px-5 py-3.5 text-slate-400 hidden md:table-cell">{d.measures}</td>
                <td className="px-5 py-3.5 text-right font-mono text-primary">{d.weight}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2 className="font-heading text-xl font-medium tracking-tight mb-4">Niveles de madurez agentic</h2>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
        {LEVELS.map((l) => (
          <div key={l.n} className="rounded-lg border border-slate-800 bg-slate-900 p-4">
            <div className={`font-mono text-2xl font-bold ${l.color}`}>N{l.n}</div>
            <div className="font-mono text-xs text-slate-500 mt-1">{l.range}</div>
            <div className="mt-2 text-sm text-slate-300">{l.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
